import Store from '@/store/computed/storeHelpers'
export default {
  computed: {
    defaultHeaders: Store.getSet({ store: 'shared', prop: 'rctiDefaultHeaders' })
  },
  data() {
    return {
      allPossibleHeaders: [
        {
          text: "ID",
          align: "left",
          value: "id",
          type: "text",
          show: false
        },
        {
          text: "Billing Period",
          align: "left",
          value: "billingPeriod",
          type: "text",
          show: false
        },
        {
          text: "Date",
          align: "left",
          value: "date",
          type: "date",
          show: false
        },
        {
          text: "Reference",
          align: "left",
          value: "externalRef",
          type: "text",
          show: false
        },
        {
          text: "Project",
          align: "left",
          value: "project.name",
          type: "text",
          show: false
        },
        {
          text: "Sub-contractor",
          align: "left",
          value: "contractor.name",
          type: "text",
          show: false
        },
        {
          text: "ABN",
          align: "left",
          value: "abn",
          type: "text",
          show: false
        },
        {
          text: "Trips",
          align: "right",
          value: "tripCount",
          type: "text",
          show: false
        },
        {
          text: "Hours",
          align: "right",
          value: "hoursTotal",
          type: "num",
          decimals: 1,
          show: false
        },
        {
          text: "Tip Weight",
          align: "right",
          value: "siteWeightTotal",
          type: "num",
          decimals: 0,
          show: false
        },
        {
          text: "Truck Weight",
          align: "right",
          value: "scaleWeightTotal",
          type: "num",
          decimals: 0,
          show: false
        },
        {
          text: "Site Weight",
          align: "right",
          value: "tipWeightTotal",
          type: "num",
          decimals: 0,
          show: false
        },
        {
          text: "Total",
          align: "right",
          value: "total",
          type: "curr",
          show: false
        },
        {
          text: "Notes",
          align: "left",
          value: "notes",
          type: "text",
          show: false
        },
        {
          text: "Status",
          align: "left",
          value: "status",
          type: "text",
          show: false
        },
        {
          text: "Type",
          align: "left",
          value: "type",
          type: "text",
          show: false
        },
        {
          text: "Enter by",
          align: "left",
          value: "user.name",
          type: "text",
          show: false
        },


      ],
    }
  }
}